import { ECompanyInfoRoute } from '~/core/models'

export const TAB_EARN_LINK = ECompanyInfoRoute.EARN
export const TAB_STOCK_PREDICTIONS_LINK = ECompanyInfoRoute.STOCK_PREDICTIONS
export const TAB_HISTORICAL_DATA_LINK = ECompanyInfoRoute.HISTORICAL_DATA
export const TAB_COMPARABLE_COMPANIES_LINK = ECompanyInfoRoute.COMPARABLE_COMPANIES
export const TAB_EDGAR_REPORT_LINK = ECompanyInfoRoute.EDGAR_REPORT
export const TAB_FULL_EDGAR_REPORT_LINK = ECompanyInfoRoute.FULL_EDGAR_REPORT

export const TAB_LINKS = [
  {
    label: 'forecastInfo.tabs.commonForecast',
    name: TAB_EARN_LINK,
  },
  {
    label: 'forecastInfo.tabs.stockPricePredictions',
    name: TAB_STOCK_PREDICTIONS_LINK,
  },
  {
    label: 'forecastInfo.tabs.historicalData',
    name: TAB_HISTORICAL_DATA_LINK,
  },
  {
    label: 'forecastInfo.tabs.peersCompanies',
    name: TAB_COMPARABLE_COMPANIES_LINK,
  },
  {
    label: 'forecastInfo.tabs.edgarReport',
    name: TAB_EDGAR_REPORT_LINK,
  },
  {
    label: 'forecastInfo.tabs.fullEdgarReport',
    name: TAB_FULL_EDGAR_REPORT_LINK,
    private: true,
  },
]
